export const invoicesConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getGeneralInvoices_request: "getGeneralInvoices_request",
        getGeneralInvoices_success: "getGeneralInvoices_success",
        getGeneralInvoices_failure: "getGeneralInvoices_failure",

        getCompanyInvoices_request: "getCompanyInvoices_request",
        getCompanyInvoices_success: "getCompanyInvoices_success",
        getCompanyInvoices_failure: "getCompanyInvoices_failure",
    }

    let obj_formatted = {};
    let domain = "distributorPortal.invoices/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}